// extracted by mini-css-extract-plugin
export default {"section":"not-found_section__D7rFm","inner":"not-found_inner__GKybA","title":"not-found_title__WzJok","body":"not-found_body__FRv5y","cta":"not-found_cta__vAnza"};